<div class="cvds-field-table">
  <div class="card cv-card__main shadow-sm">
    <div class="card-header" *ngIf="title">{{title}}</div>
    <div class="card-body" *ngIf="itemsChunk.length > 0">
      <div class="row" *ngFor="let item of itemsChunk">
        <div class="col-sm-4" *ngFor="let field of item"><cv-cvds-field [field]="field"></cv-cvds-field></div>
      </div>
    </div>
  </div>
</div>